import { useApplicationConfigStore } from '~/store/application-config'
import { useBorrowerStore } from '~/store/borrower'
import { useRootStore } from '~/store/root'
import { useIdentityStore } from '~/store/identity'
import { ApplicationConfigService } from '~/libs/store-services/application-config-service'

function readQueryParam(value) {
  if (Array.isArray(value)) {
    return value[value.length - 1]
  }
  return value
}

function loadAnswersFromParams(query) {
  const applicationConfigService = new ApplicationConfigService()

  const answers = {
    'financeAmount': readQueryParam(query.amountSeeking) || readQueryParam(query.financeAmount)
  }
  const validators = {
    'financeAmount': /^\d+$/
  }

  for (const key in answers) {
    const answerEmpty = answers[key] === null || answers[key] === undefined
    if (answerEmpty) {
      delete answers[key]
      continue
    }
    if (validators[key] && !validators[key].test(answers[key])) {
      console.warn('Not saving data from params because it doesn\'t match validation.', { [key]: answers[key] })
      delete answers[key]
    }
  }

  if (Object.keys(answers).length <= 0) {
    return
  }

  applicationConfigService.mergeAnswersToStorage(answers)
}

export default defineNuxtRouteMiddleware(async (to) => {
  setTrackingCookiesFromParams(to.query)
  loadAnswersFromParams(to.query)

  const { entrypointIdentifier } = getAppConfigRouteData(to)
  const { borrower } = useBorrowerStore()
  const { isLoggedIn, isEmbedded } = useRootStore()
  const appConfigStore = useApplicationConfigStore()
  const { mustSetPassword } = useIdentityStore()

  await appConfigStore.getApplicationConfigData({ entrypointIdentifier: entrypointIdentifier || null })
  const { applicationConfig } = appConfigStore

  if (!applicationConfig) {
    throw createError({
      statusCode: 500,
      statusMessage: 'Application Config fetch failed for requirements',
      fatal: true
    })
  }

  const moduleData = applicationConfig?.module
  const isAuthRequired = moduleData != null && moduleData.authRequired !== false

  if ((!isLoggedIn || !borrower) && isAuthRequired) {
    return redirectToWidget(to.path)
  }

  if (!isEmbedded && isAuthRequired && mustSetPassword) {
    return navigateTo(`/newpass?r=${encodeURIComponent(to.path)}`)
  }

  const { isNonLinearExperimentActive } = useNonLinearExperiment()
  if (!isNonLinearExperimentActive() || !applicationConfig?.allowNonLinear) {
    const { singleConfigBaseRoute, experienceBaseRoute } = useApplicationConstants()
    const linearPath = entrypointIdentifier
      ? `/${singleConfigBaseRoute}/${entrypointIdentifier}`
      : `/${experienceBaseRoute}`
    return navigateTo({ path: linearPath, query: to.query }, { replace: true })
  }

  to.meta.layout = isEmbedded ? 'embedded' : 'guest-flow'
})
